/* RavenTorch — price change animation.

   Deliberately decoupled from rt-buy.js. That file owns the arithmetic; this one
   only notices that the rendered figure changed and reacts. A MutationObserver
   on the text node means the animation fires for every path that can ever change
   the total — the stepper, typing a number straight into the field, a variant
   swap, or anything added later — without rt-buy.js having to know this exists.

   Direction matters: going up should feel like the number arriving from below,
   going down like it dropping in from above. Same motion, opposite sign; the eye
   reads it before the brain reads the digits.
*/
(function () {
  'use strict';

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Money strings arrive formatted for the shop's locale: €59,99 here, but
     €1,199.98 on a comma-thousands shop. Decide which separator is decimal by
     looking at the last one and how many digits follow it, rather than assuming
     a convention that changes the moment the store currency does. */
  function num(str) {
    if (!str) return NaN;
    var s = String(str).replace(/[^0-9.,-]/g, '');
    if (!s) return NaN;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var cut = Math.max(lastDot, lastComma);
    if (cut > -1 && s.length - cut - 1 <= 2 && s.length - cut - 1 > 0) {
      s = s.slice(0, cut).replace(/[.,]/g, '') + '.' + s.slice(cut + 1);
    } else {
      s = s.replace(/[.,]/g, '');
    }
    return parseFloat(s);
  }

  function watch(el) {
    if (!el || el.__rtTickBound) return;
    el.__rtTickBound = true;

    var last = el.textContent.trim();

    var fire = function () {
      var now = el.textContent.trim();
      if (now === last) return;

      var before = num(last);
      var after = num(now);
      last = now;
      if (reduce) return;

      var dir = (isNaN(before) || isNaN(after) || after >= before) ? 'up' : 'down';

      /* Removing both classes and forcing a reflow restarts the animation even
         when the direction has not changed — without it, holding the + button
         plays the first step and then nothing. */
      el.classList.remove('rt-tick--up', 'rt-tick--down');
      void el.offsetWidth;
      el.classList.add('rt-tick--' + dir);

      var row = el.closest('.rt-total');
      if (row) {
        row.classList.remove('is-ticking');
        void row.offsetWidth;
        row.classList.add('is-ticking');
      }
    };

    new MutationObserver(fire).observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function bind(root) {
    var sel = '[data-rt-total], [data-rt-stick-total], [data-rt-price]';
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  /* The theme editor re-renders whole sections; re-bind when it does. */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });

  window.rtBindPriceTicks = bind;
})();
